var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 153,
    viewBox: "0 0 274 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6624_28577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.408 80.0155C165.408 78.3849 164.077 77.0625 162.435 77.0625H114V133.289C114 134.92 115.331 136.242 116.972 136.242",
    stroke: "#2866A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.353 85.9296C171.353 84.299 170.022 82.9766 168.381 82.9766H119.945V139.203C119.945 140.834 121.276 142.156 122.917 142.156H154.741C155.341 142.156 155.842 141.699 155.882 141.102C156.162 137.105 158.023 133.347 160.795 130.811C163.267 128.544 166.689 127.063 170.292 126.814C170.893 126.775 171.353 126.278 171.353 125.681V85.9296Z",
    stroke: "#2866A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.379 106.352L141.88 118.77L135.625 112.566",
    stroke: "#2866A9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.111 131.312C165.087 131.312 160.203 136.165 160.203 142.15C160.203 148.136 165.087 152.988 171.111 152.988C177.135 152.988 182.019 148.136 182.019 142.15C182.019 136.165 177.135 131.312 171.111 131.312ZM172.052 148.106C171.982 148.265 171.892 148.394 171.782 148.504C171.672 148.613 171.531 148.702 171.371 148.772C171.211 148.832 171.041 148.871 170.871 148.871C170.701 148.871 170.521 148.842 170.361 148.772C170.2 148.702 170.06 148.623 169.95 148.504C169.84 148.384 169.74 148.255 169.68 148.106C169.61 147.947 169.58 147.788 169.58 147.599C169.58 147.41 169.61 147.261 169.68 147.102C169.75 146.943 169.84 146.813 169.95 146.694C170.06 146.575 170.2 146.495 170.361 146.426C170.521 146.356 170.691 146.326 170.871 146.326C171.051 146.326 171.211 146.356 171.371 146.426C171.531 146.495 171.661 146.585 171.782 146.694C171.902 146.803 171.982 146.943 172.052 147.102C172.122 147.261 172.152 147.43 172.152 147.599C172.152 147.768 172.122 147.947 172.052 148.106ZM174.343 140.39C174.223 140.699 174.063 140.977 173.873 141.206C173.683 141.434 173.483 141.633 173.253 141.802C173.032 141.971 172.822 142.13 172.622 142.279C172.422 142.429 172.252 142.578 172.112 142.717C171.972 142.856 171.882 143.025 171.852 143.204L171.651 144.437H170.21L170.07 143.055C170.07 143.055 170.07 143.005 170.07 142.985V142.916C170.07 142.667 170.13 142.448 170.26 142.269C170.381 142.09 170.541 141.912 170.731 141.752C170.921 141.593 171.121 141.434 171.331 141.285C171.551 141.136 171.752 140.967 171.932 140.788C172.122 140.609 172.272 140.41 172.402 140.181C172.532 139.953 172.592 139.694 172.592 139.386C172.592 139.187 172.552 138.998 172.472 138.839C172.392 138.68 172.292 138.541 172.152 138.422C172.012 138.302 171.852 138.213 171.661 138.153C171.471 138.093 171.261 138.064 171.041 138.064C170.721 138.064 170.441 138.103 170.22 138.173C170 138.243 169.81 138.322 169.65 138.412C169.49 138.501 169.36 138.581 169.25 138.65C169.14 138.72 169.05 138.76 168.96 138.76C168.759 138.76 168.609 138.68 168.519 138.511L167.969 137.636C168.159 137.467 168.369 137.308 168.599 137.159C168.829 137.01 169.08 136.871 169.34 136.761C169.6 136.652 169.9 136.562 170.21 136.493C170.521 136.423 170.861 136.393 171.221 136.393C171.712 136.393 172.162 136.463 172.572 136.592C172.982 136.731 173.323 136.92 173.613 137.169C173.903 137.417 174.123 137.726 174.283 138.074C174.444 138.432 174.524 138.829 174.524 139.267C174.524 139.704 174.464 140.062 174.333 140.38L174.343 140.39Z",
    fill: "#DA1C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9531 96.3438H41.781",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26457 90.1177C7.26457 91.8477 8.6756 93.2596 10.4269 93.2596C11.2675 93.2596 12.0281 92.9315 12.5985 92.4045C13.2089 91.8278 13.5892 91.0225 13.5892 90.1177V90.0978C13.5892 86.6476 10.7671 83.8438 7.29459 83.8438C3.82206 83.8438 1 86.6476 1 90.0978C1 93.5479 3.82206 96.3518 7.29459 96.3518H23.2863",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4283 13.5469L1 13.6569",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1103 7.0161V6.99622C39.1103 3.54606 41.9324 0.742188 45.4049 0.742188C48.8775 0.742188 51.6995 3.54606 51.6995 6.99622C51.6995 10.4464 48.8775 13.2502 45.4049 13.2502L21.1172 13.469",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.745 124.68C243.745 127.017 245.646 128.906 247.998 128.906C249.129 128.906 250.15 128.468 250.92 127.752C251.741 126.977 252.261 125.883 252.261 124.67V124.64C252.261 119.987 248.468 116.219 243.785 116.219C239.101 116.219 235.309 119.987 235.309 124.64C235.309 129.294 239.101 133.062 243.785 133.062H226.812",
    stroke: "#DFE5FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.24 37.5H212.242",
    stroke: "#DEE4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.496 18.8485C272.445 14.7321 268.692 11.6797 264.229 11.6797C261.297 11.6797 258.665 12.9921 256.904 15.0602C255.493 16.7207 254.652 18.8584 254.652 21.195C254.652 21.3938 254.672 21.5927 254.682 21.7915C253.731 21.4038 252.69 21.195 251.6 21.195C247.066 21.195 243.394 24.844 243.394 29.3481C243.394 33.8522 247.066 37.5012 251.6 37.5012H231.945",
    stroke: "#DEE4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1833 53.1376C49.2942 53.1376 50.1948 52.2429 50.1948 51.1391C50.1948 50.0354 49.2942 49.1406 48.1833 49.1406C47.0724 49.1406 46.1719 50.0354 46.1719 51.1391C46.1719 52.2429 47.0724 53.1376 48.1833 53.1376Z",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.651 89.7656H232.539",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.102 91.3032V88.2109",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.667 136.93H66.5547",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1172 138.483V135.391",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0683 56.1641H38.8438",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9531 59.2547V53.0703",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1 95.4922H227.875",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.984 98.5829V92.3984",
    stroke: "#CF1C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6624_28577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 153,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/Confirmation.6b4138c1a4bed2b6b20515beb3e5e76b.svg";
export { ForwardRef as ReactComponent };